"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grimacco": {
    "3b3c96e0": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "arbida": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d032500": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "canalaz": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b48b1672": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "dolina": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79f07da7": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "podlach": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "410f754f": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "scale": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45d443cb": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "skipSearch": false
    }],
    "slapovicco": [{
      "hkey": "d48cb6c9",
      "slug": "grimacco",
      "name": "Grimacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;